import { XMarkIcon } from '@heroicons/react/24/outline';
import { Button, Icon, Input } from '../..';
import React, { useRef, useState } from 'react';
import { cn, useBreakpoints, useOnClickOutside } from '@jobcost-monorepo/utils';
import { useTranslation } from '@jobcost-monorepo/i18n';

interface Props {
  initialValue?: string;
  handleChangeSearch: (value?: string) => void;
}

const SearchBar = ({ initialValue = '', handleChangeSearch }: Props) => {
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState<string>(initialValue);
  const [isFocused, setIsFocused] = useState<boolean>(false);
  const inputFilled = searchTerm && searchTerm.length > 0;
  const searchRef = useRef(null);
  const { isSmall } = useBreakpoints();

  const handleSearch = async (value: string) => {
    handleChangeSearch(value);
  };

  const handleResetSearch = () => {
    setSearchTerm('');
    handleChangeSearch(undefined);
  };

  const handleClickInput = () => {
    setIsFocused(true);
  };

  const handleKeyDown = async (
    event: React.KeyboardEvent<HTMLInputElement>,
  ) => {
    if (event.key === 'Enter') {
      await handleSearch(searchTerm);
    }
  };

  useOnClickOutside(searchRef, () => {
    setIsFocused(false);
  });

  return (
    <div
      className="relative min-w-64 w-full pb-2 max-w-[30rem]"
      ref={searchRef}
    >
      <div className="flex flew-row space-x-2">
        <Input
          value={searchTerm}
          key="search"
          type="text"
          id="search"
          autoComplete="off"
          placeholder={t('search')}
          onChange={(e) => setSearchTerm(e?.target?.value ?? '')}
          onClick={handleClickInput}
          onKeyDown={(e) => handleKeyDown(e)}
        />
        {inputFilled && isFocused && (
          <div
            onClick={handleResetSearch}
            className={cn(
              'absolute h-full inset-y-0 right-0 flex items-center pr-20 pb-2 cursor-pointer',
            )}
          >
            <XMarkIcon
              className="h-5 w-5 text-gray-400 cursor-pointer"
              aria-hidden="true"
            />
          </div>
        )}
        <Button
          type="submit"
          onClick={() => handleSearch(searchTerm)}
          className="z-50"
        >
          {isSmall ? (
            <Icon iconName="search" className="fill-white stroke-white" />
          ) : (
            t('search')
          )}
        </Button>
      </div>
    </div>
  );
};

export default SearchBar;
